/**
 * 存放所有的接口地址
 */

export default {
  //pc端列表每页条数
  projectListSize: 9, //项目列表每页条数
  newsListSize1: 6, //新闻图文列表每页条数
  newsListSize2: 10, //新闻普通列表每页条数


  //公用
  checkPhoneHas: 'pub-checkUnitUserPhone', //监测单位管理员是否存在
  changeGuideStatus: "pub-changeStep", //更改执行机构端引导页状态
  sendCodeUrl: 'users-sendSmsCode', //用户登录发送发送验证码
  getRegionUrl: 'getDistinctList', //获取地区数据
  submitForgetPwd: 'pub-resetPassword', //单位工作人员忘记密码
  getDictParam: 'getDictParam', //字典表
  uploadImgUrl: 'basePictureUpload', //上传图片
  uploadFileUrl: 'uploadFile', //上传文件
  downloadFileUrl: 'downloadFile', //下载文件
  downloadZipFileUrl: 'downloadZipFile',
  downReportTempFile: 'subject-getTemplate', //下载结算花名册模板

  getMapData: 'index-indexMapData', //获取首页地图数据


  //单位系统相关
  getUserInfoByToken: 'pub-getInfoByToken', //根据token获取用户信息
  registerUnitUrl: 'pub-unitAdd', //注册单位接口
  getCheckRegion: 'pub-checkUnitAddress', //检测该地区是否已有注册医院
  doUserLoginUrl: 'users-userLoginin', //用户登录操作
  doUnitLoginUrl: 'pub-unitUserLoginin', //单位登录操作

  com_project: {
    apply: {
      list: "subject-getProjectPublicApplyList", //救助花名册
    },

    donate: { //公益捐款信息
      list: "subject-getDonationList",
      insert: "subject-donationAdd",
      update: "subject-donationEdit",
      info: "subject-donationDetails",
      delete: "subject-donationDelete", //删除
    },
    launch: {
      list: "subject-getBeforeApprovalListByProvince",
      info: "subject-getBeforeApprovalDetails",
      update: "subject-editBeforeApproval",
      insert: "subject-addBeforeApproval",
      delete: "subject-deleteBeforeApproval",
      set: "subject-setBeforeApprovalEnable",
    },
    audit: { //省区代表审核
      approval: "subject-getAgentApprovalList", //立项审核列表
      start_audit: "subject-agentApprovalAudit", //立项审核操作
      end: "subject-getAgentNodeList", //结项审核列表
      end_audit: "subject-agentNodeAudit", //结项审核
      money: "subject-auditTotalFunds", //获取立项的相关金额
    },
    approval: {
      list: "",
      info: "subject-getProjectApprovalBaseDetails", //立项第一步详情
      detail: "subject-getProjectApprovalDetails", //公益项目申请 select 第一步获取合作项目详情
      pro_list: "subject-getMyBeforeApprovalListByProvince", //公益项目申请 能申请的项目列表 type 1 合作 2 自有
      first_add: 'subject-publicApprovalAdd', //公益项目申请  第一步首次新增操作   project_before_id 1 合作 2 自有
      first_edit: 'subject-publicApprovalFirstEdit', //公益项目申请  第一步编辑保存操作   project_before_id 1 合作 2 自有
      second: 'subject-publicApprovalPlanSave', //公益项目申请  第二步保存操作   project_before_id 1 合作 2 自有

      upload_list: 'subject-publicApprovalFilesConfig', //公益项目申请  第二步获取需要上传的文件列表   project_before_id 1 合作 2 自有
      own_pro_info: 'subject-getBrandBeforeApprovalDetails', //公益项目申请 select 第一步获取自有项目详情
      coop_pro_info: 'subject-getBeforeApprovalDetails', // 公益项目申请 select 第一步获取合作项目详情
    },

    end: {
      update: 'subject-editSubmitNodeApply', //公益项目-信息列表-结项更新资料
      insert: 'subject-submitNodeApply', //公益项目-信息列表-结项提交资料
      list: 'subject-getBeforeProjectNodeList  ', //公益合作项目事务代表提交报告列表
      url: 'subject-nodeInfoAddAndEdit', //公益项目事务代表提交修改汇总报告
      info: 'subject-getNodeInfoDetail', //公益项目事务代表获取汇总报告信息
      org_list: 'subject-getUnitByProjectBeforeId', //公益项目事务代表获取执行机构报告提交列表
    },

    info: {
      report_config: 'subject-projectPublicSimpleDetails', //获取报告相关信息
      get_report_info: 'subject-getFlowByProjectTime', //根据报告起止日期获取报告信息
      report_info: 'subject-getPublicInfoQuarterReportDetails', //阶段性报告详情
      report_add: 'subject-addPublicPhasedReport', //阶段性报告新增
      report_edit: 'subject-editPublicPhasedReport', //阶段性报告编辑
      report_list: 'subject-getPublicInfoQuarterReportList', //阶段性报告编辑列表
      report_apply_list: 'subject-getPublicApplyList', //阶段性报告的救助申请
    },
  },

  cf_project: {
    apply: { //救助申请
      list: "apply-unitApplyInfoList", //救助申请，手术拨款申请公用列表
      info: "apply-applyInfoDetails", //获取项目申请信息详情
      visit_list: "apply-getApplyVisitList", //某位救助者回访记录列表
      visit_info: "apply-applyVisitDetails", //回访记录详情
      visit_add: "apply-applyVisitAdd", //增加回访记录
      visit_question: "apply-getApplyVisitQuestionList", //回访记录内容题目
    },

    info: { //众筹项目信息
      plan_list: 'project-getPlanByProject', //申请项目获取月计划模板列表
      simple: 'project-getSimpleProjectByUnit', //获取项目简单列表
      list: 'project-getProjectListByAddress', //获取众筹单位可申请项目列表
      child_list: 'project-getProjectApplyListByProjectAndUnit ', //获取众筹单位可申请项目子列表  project_id
      files_info: 'project-getUnitAgreementsByProject', //众筹项目申请获取相关协议和救助标准  project_id
      apply_del: 'project-hospitalIsAgreeDelete', //众筹项目申请删除
      apply_end: 'project-submitNodeApply', //众筹项目申请结项
      end_edit: 'project-editNodeApply', //众筹项目申请结项编辑
      end_info: 'project-getNodeApplyDetail', //众筹项目申请结项详情
      status_info: 'getAuditConfigList', //获取下拉选择列表
    },

    payout: {
      export1: 'apply-exportUnitApplyInfoList', //手术项目费用组成单导出
      export2: 'project-exportProjectListByUnit', //非手术项目费用组成单导出
    }
  },

  user: {
    list: 'pub-unitUserList', //获取执行机构管理人员列表
    insert: 'pub-unitUserAdd', //新增执行机构管理人员
    update: 'pub-unitUserEdit', //编辑执行机构管理人员
    delete: 'pub-unitUserDelete', //删除执行机构管理人员
    info: 'pub-unitUserDetail', //执行机构管理人员详情
  },


  getComprojectLaunchList: "subject-getBeforeApprovalListByProvince", //获取公益事务代表省区项目列表

  publicBuildApprovalReadFile: 'subject-getProjectPublicApprovalReadTemplate', //项目立项必读文件
  publicBuildAgress: 'subject-publicApprovalAgreeSave', //公益项目立项-捐赠协议
  publicBuildProjectLists: 'subject-getMyBeforeApprovalListByProvince', //公益项目立项-立项第一步获取项目列表
  proList1: 'subject-getMyBeforeApprovalListByProvince', //能
  getInfoByProject: 'subject-getBeforeApprovalDetails', //公益项目立项-立项第一步根据项目id获取信息
  publicBuildFirstAdd: 'subject-publicApprovalAdd', //公益项目立项-立项第一步新增
  publicBuildFirstEdit: 'subject-publicApprovalFirstEdit', //公益项目立项-立项第一步编辑
  approvalSave: 'subject-publicApprovalPlanSave', //公益项目立项-第二步保存草稿（新增编辑）
  publicBuildSubmit: 'subject-publicApprovalSubmit', //公益项目立项-全部提交
  // publicBuildEdit:"subject-publicApprovalEdit",//公益项目立项-编辑保存
  publicBuildDel: 'subject-publicApprovalDelete', //公益项目立项-删除

  getComProReportNeedInfo: 'subject-getNoReportList', //公益项目-提交阶段性报告-获取报告阶段
  getComProReportPayInfo: 'subject-getFlowByProjectAndReport', //公益项目-提交阶段性报告-获取报告阶段捐款信息

  publicBuildDetails: 'subject-getProjectApprovalDetails', //公益项目立项-详情-全部
  publicBuildBaseDetails: 'subject-getProjectApprovalBaseDetails', //公益项目立项-详情-基础
  publicBuildPlanDetails: 'subject-getProjectApprovalPlanDetails', //公益项目立项-详情-计划
  publicBuildAgressDetails: 'subject-getProjectApprovalAgreeDetails', //公益项目立项-详情-捐赠
  publicBuildAgressDonee: 'website-getDoneeInfo', //  公益项目立项-详情-捐赠人
  publicBuildList: 'subject-getProjectApprovalList', //公益项目立项-列表
  publicBuildSeal: 'subject-uploadStampAgreement', //公益项目-列表-提交盖章附件

  getConfirmPayList: 'subject-getFundsPlanNewList', //公益项目-捐款-列表
  getBudgetList: 'subject-getFundsReturnList', //公益项目-拨捐款列表信息
  addBudgetInfo: 'subject-returnAdd', //公益项目-拨捐款列表信息-添加回款
  getBudgetInfo: 'subject-returnDetails', //公益项目-拨捐款列表信息-回款信息
  addPayFundsInfo: 'subject-hospitalPaymentFlowAdd', //公益项目-捐款-提交捐款信息
  editPayFundsInfo: 'subject-hospitalPaymentFlowEdit', //公益项目-捐款-编辑捐款信息
  checkPayFundsInfo: 'subject-checkOptionAndMoney', //公益项目-捐款-检测捐款和限制金额
  getPayFundsDetail: 'subject-hospitalPaymentFlowDetails', //公益项目-捐款-提交捐款凭证详情


  getCfProPayList: 'project-getPaymentList', //众筹项目-捐款申请-列表
  getPublicProjectList: 'subject-getConfirmPayPublicList', //公益项目-捐款-获取公益项目简单列表
  checkProjetAdvancePayment: 'subject-checkAdvancePayment', //公益项目-捐款-项目是否存在需还款垫付信息

  addMediaCoverage: 'apply-addMediaCoverage', //添加媒体报道
  mediaCoverageList: 'apply-mediaCoverageList', //媒体报道列表
  mediaCoverageDetail: 'apply-mediaCoverageDetail', //媒体报道详情
  mediaCoverageEdit: 'apply-editMediaCoverage', //媒体报道编辑



  deletePayFunds: 'subject-deleteSubmitPayFunds', //删除捐款凭证 单条删除
  publicComProjectList: 'subject-getProjectPublicInfoList', //公益项目-列表
  publicComProjectInfoDetails: 'subject-getPublicInfoDetails', //公益项目-详情-基础信息
  publicComProjectInfoFunds: 'subject-getPublicInfoFunds', //公益项目-详情-执行机构捐款信息
  publicComProjectInfoApplyPay: 'subject-getPublicInfoApplyPay', //公益项目-详情-申请捐款和打款信息
  getComProOtherMoney: 'subject-getPublicInfoRemainderMoney', //公益项目-相关金额
  publicComProjectInfoNodeDetails: 'subject-getPublicInfoNodeDetails', //公益项目-详情-结项信息
  publicComProjectInfoPushReport: 'subject-getPublicInfoPhasedReport', //公益项目-详情-阶段报告

  getProjectEndInfo: 'subject-getNodeApplyDetails', //公益项目-信息列表-获取结项资料

  getProjectPublicNodeTotal: 'subject-getProjectPublicNodeTotal', //公益项目-信息列表-结项提交资料-项目摘要
  getComProPayOutExtendInfo: 'subject-getPaymentApplyAbout', //公益项目-信息列表-申请拨款资料-获取扩展信息
  getCfReportOption: 'subject-getNoReportList', //公益项目-获取待提交阶段性报告
  getSeasonPhaseReport: 'subject-getPublicPhasedReportCount', //公益项目-获取-季度的阶段性报告
  publicPaymentApply: 'subject-paymentApply', //公益项目-申请捐款资料
  publicPaymentApplyEdit: 'subject-editPaymentApply', //公益项目-申请捐款资料编辑
  publicPaymentHistory: 'subject-getPayMoneyHistory', //公益项目-申请捐款历史资料
  publicPaymentList: 'subject-getPublicApplyPayList', //公益项目-申请捐款列表
  publicPaymentDetails: 'subject-getPaymentApplyDetails', //公益项目-申请捐款详情
  getApplyComprojectList: 'apply-applyProjectList', //获取可以申请的项目列表  project_type 公益1 众筹2
  // publicPaymentApply:'subject-paymentApply',//公益项目-申请-列表
  deleteProjectApply: 'apply-applyInfoDelete', //公益项目-申请-删除操作
  sumbitProjectApplyForm: 'apply-applyInfoAdd', //众筹项目-救助申请-新增操作
  updateProjectApplyForm: 'apply-applyInfoEdit', //众筹项目-救助申请-编辑操作
  getComProListForApply: 'subject-getRunProjectPublicList', //公益项目-导入-获取可导入花名册的项目
  getComProListApplyDetails: 'subject-projectPublicApplyDetails', //公益项目-导入-获取花名册的人详情

  lookComProApplyNoAudit: 'subject-getLastAuditNoOpinion', //救助花名册查看审核不通过意见
  comProListApplySubmit: 'subject-projectPublicApplyEdit', //公益项目-导入-获取花名册的人详情提交编辑
  comProListApplyEdit: 'subject-projectPublicApplySaveEdit', //公益项目-导入-获取花名册的人详情保存编辑

  comProListApplyDelete: 'subject-deleteProjectPublicApply', //公益项目-导入-获取花名册的记录删除

  getStageListByProId: 'subject-getReportByProjectList', //公益项目-导入-根据项目id获取阶段
  getComProApplyTemplate: 'subject-getTemplate', //公益项目-导入-下载救助花名册模板
  comProApplyExport: "subject-importApply", //公益项目-导入-导入救助花名册
  getProjectApplyList: 'apply-unitApplyInfoList', //获取项目申请信息列表   project_type 1公益 2众筹
  getProjectApplyDetail: 'apply-applyInfoDetails', //获取项目申请信息详情
  getReportBudgetInfo: 'subject-projectPublicApprovalSimpleDetails', //获取阶段性报告-财务预算信息
  getNoReportList: 'subject-getNoReportList', //获取公益项目阶段报告可提交的列表

  getUnitMoneyByProId: 'project-getUnitProjectBlance', //获取执行机构某个项目的分配金额、已结算余额、待结算金额、项目余额

  // getCfProjectList:'project-getProjectListByUnit',//获取众筹项目列表
  getCfProjectList: 'project-getProjectListByAddress', //获取众筹单位可申请项目列表
  // getCfProjectAppropriation: "project-getProjectListByUnit", //获取非手术项目众筹拨款申请列表
  getCfProjectAppropriation: "project-getPaymentListUnit", //获取非手术项目众筹拨款申请列表
  getCfProPayApplyInfo: 'project-getPaymentDetail', //众筹项目-拨款管理-获取拨款信息
  submitCfProPayApplyInfo: 'project-submitPayment', //众筹项目-拨款管理-提交拨款申请信息
  updateCfProPayApplyInfo: 'project-editPayment', //众筹项目-拨款管理-修改拨款申请信息
  getCfProPayVoucherPics: 'project-getPaymentPic', //众筹项目-拨款管理-获取打款凭证图片

  submitCfProReport: 'project-projectPhasedSummaryReportAdd', //众筹项目提交阶段性报告
  getCfProPayProjectList: 'project-getHospitalIsAgree', //众筹项目-拨款管理-获取符合要求的项目(有同意协议标识)
  submitCfProAgreeAg: 'project-hospitalIsAgree', //众筹项目-提交协议附件


  getCfProApplyExtendInfo: 'apply-applyProjectExtendInfo', //根据项目id获取申请扩展信息、表单
  getCfProApplyUserTypes: 'apply-projectUserTypes', //根据项目id获取获取项目贫困类型
  getEyeTypeByUserType: 'apply-getFundsUse', //根据贫困选项获取眼疾种类
  getcfProLastPayApplyInfo: 'project-getLastInputAndTotal', //众筹项目-申请拨款-获取上一次的信息
  getCfProPayReadMeList: 'project-getAgreeFileList', //众筹项目-申请信息-获取该项目必读协议
  getCfProReportList1: 'project-getNoReportList', //众筹项目-申请信息-获取待提交报告列表
  getCfProReportList: 'project-getProjectPhasedSummaryReportList', //众筹项目-项目信息-报告列表
  getCfProReportDetail: 'project-ProjectPhasedSummaryReportDetails', //众筹项目-项目信息-报告详情
  getCfProAgDetail: 'project-getUnitAgreements', //众筹项目-项目信息-获取协议
  getCfProApplyAuditText: 'project-getAuditOpinion', //众筹项目-申请-获取申请审核意见
  getCfProApplyPayAuditText: 'project-getAuditOpinion', //众筹项目-申请-获取拨款审核意见
  getCfProPayInfoByProjectId: 'project-getLastInputAndTotal', //众筹项目-拨款管理-根据项目获取该拨款申请信息
  getCfProPayInfoById: 'project-getPaymentDetail', //众筹项目-拨款管理-获取该拨款申请信息，
  getCfProInfo: 'project-getProjectInfoDetail', //众筹项目-申请信息-获取申请信息详情，
  getCfProApplyEditInfo: 'apply-applyInfoDetailForEdit', //众筹项目-救助申请-获取该救助申请编辑信息，
  insertVisitInfo: 'apply-applyVisitAdd', //众筹项目-救助申请-新增走访记录，



  getUserManagementList: 'pub-unitUserList', //获取执行机构管理人员列表
  addUserManagement: 'pub-unitUserAdd', //新增执行机构管理人员
  editUserManagement: 'pub-unitUserEdit', //编辑执行机构管理人员
  delUserManagement: 'pub-unitUserDelete', //删除执行机构管理人员
  UserManagementDetail: 'pub-unitUserDetail', //执行机构管理人员详情
  getUnitInfoUrl: 'pub-unitDetails', //获取单位信息 参数token
  submitUnitInfo: 'pub-unitEdit', //保存单位信息 参数obj


  //pc前端相关
  getWebInfoUrl: 'website-getWebsiteInfo', //获取网站信息
  getChannelDataUrl: 'website-getSimpleWebsiteChannelList', //获取网站导航
  getBannerDataUrl: 'website-getSimpleWebsiteAdsList', //获取轮播图片
  getNewsIndexUrl: 'index-indexNewsList', //获取首页推荐新闻
  getProjectIndexUrl: 'index-indexProjectList', //获取首页项目列表
  getIndexNewsListUrl: 'index-indexMessageList', //获取首页信息披露
  getChildByChidUrl: 'website-getSubChannels', //根据一级导航id获取二级导航
  getPhotosByYear: 'news-picContentByYearAndChannel', //根据年份获取新闻图集列表
  getDataByChidUrl: 'website-getChannelData', //根据导航id获取数据
  getNewsDetailUrl: 'news-newsDetails', //获取新闻详情
  getRecommendNewsList: 'news-getNewsViewNumList', //获取推荐信息列表
  getOrgListUrl: 'pub-getOrgList', //获取合作伙伴列表
  indexDonationList: 'index-indexDonationList', //获取首页捐赠数据
  indexMapData: 'index-indexMapData', //首页地图
  applyInfoAddPc: 'apply-applyInfoAddPc', //pc端救助申请
  applyInfoPcDetail: 'apply-applyInfoPcDetail', //pc端救助详情
  applyInfoEditPc: 'apply-applyInfoEditPc', //   pc端救助编辑
  projectDetais: 'news-newsProjectDetails', //项目详情
  getProjectByYear: 'news-projectContentByYear', //根据年份获取项目详情内容

  projectMediaList: 'project-getProjectInfoMediaCoverage', //获取项目新闻关联的媒体报道列表
  projectMediaDetail: 'project-projectMediaCoverageDetail', //获取项目新闻关联的媒体报道详情
  // projectProgressList:'project-getProjectInfoProgressList',//项目-进展
  // projectDonationList:'project-getProjectInfoDonationList',//项目-爱心流水
  getSimpleUnitList: 'pub-getSimpleUnitList', //执行机构数据
  newsPageDetails: 'news-newsPageDetails', //单页数据

  //志愿者相关
  getVolunteerSkill: 'volunteer-getSkillList', //获取志愿者技能信息
  getVolunteerAgreement: 'volunteer-getVolunteerAgreement', //获取志愿者承诺书
  getVolunteerDetails: 'volunteer-volunteerInfoDetails', //获取志愿者详情
  addVolunteer: 'volunteer-volunteerInfoAdd', //志愿者新增
  editVolunteer: 'volunteer-volunteerInfoEdit', //志愿者编辑
  addVolunteerBranch: 'volunteer-volunteerBranchAdd', //新增志愿者工会
  getIfVolunteer: 'volunteer-getIfVolunteer', //判断是否是志愿者
  getVolunteerBranchDetails: 'volunteer-volunteerBranchDetails', //获取志愿者工会详情
  saveVolunteerBranch: 'volunteer-volunteerBranchEdit', //编辑志愿者工会
  getNationList: 'volunteer-getNationList', //民族接口
  getHospitalByAddress: 'volunteer-getAreaUnitList', //根据地址获取最近执行机构接口
  getVolAndBranchInfo: 'volunteer-getVolAndBranchInfo' //获取志愿者或者分会信息


}



// WEBPACK FOOTER //
// ./src/config/url.js